(function () {
    'use strict';

    angular.module('swif.reservations')
    .service('openresaPlanningService', openresaPlanningService);

    function openresaPlanningService($q, $interval, swif, swifRouteService, openresaRightsService, openresaRequestService, openresaBookingService, openresaHumanResourcesService) {
        'ngInject';
        var service = {};
        // service attributes
        service.productColor = {};
        service.productName = {};
        service.productType = {};
        service.routerDefer = $q.defer();
        service.collectionName = 'planningReservations';
        service.PANEL_FIELDS = [
            'id', 'name', 'note', 'checkin', 'checkout', 'partner_id',
            'partner_invoice_id', 'state', 'reservation_line',  
            'recipient', 'recipient_phone', 'shipping_address', 'shipping_wished_date'
        ];
        service.ROUTER_ACTIONS = ['router_edit', 'router_delete', 'router_cancel'];

        // service methods
        service.resolveData = resolveData;
        service.getCollection = getCollection;
        service.initCollection = initCollection;
        service.getCalendarFilter = getCalendarFilter;
        service.routerProxyDismiss = routerProxyDismiss;
        service.getFullcalendar = getFullcalendar;
        service.getColor = getColor;
        service.fromOdooEvents2Fullcalendar = fromOdooEvents2Fullcalendar;
        service.canSeeEventDetails = canSeeEventDetails;
        service.loadProductColors = loadProductColors;
        service.addBookableExtraFilter = addBookableExtraFilter;
        service.getSiteParams = getSiteParams;
        service.getEquipmentParams = getEquipmentParams;
        service.preModal = preModal;
        service.preValidate = preValidate;
        service.routerDispatch = routerDispatch;
        service.callback = callback;

        // initialize some values once application is loaded
        swif.settings.initialize().then(function (settings) {
            service.reservationStates = settings.getContentType('reservation').states;
        });

        function resolveData() {
            function checkResources() {
                var resources = ['fullcalendar'];
                return swif.route.check({ resources: resources });
            }
            function loadResources() {
                return openresaHumanResourcesService.resolveData({});
            }

            return swif.settings.initialize()
                .then(checkResources)
                .then(loadResources);
        }

        function getCollection () {
            return swif.collections.getCollection(service.collectionName);
        }

        function initCollection (filter, options) {
            var collectionName = service.collectionName;
            return swif.collections.createOrUpdate(collectionName, 'reservation', filter, options);
        }

        function getCalendarFilter (start, end, selectedResources, srcCollection, noSelectedRessources) {
            var params = {};

            if(srcCollection) {
                params = angular.copy(srcCollection.currentFilter);
                swif.data.resetExtraFilter(params, 'currentCalendar');
            }
            params.fields = ['name', 'note', 'checkin', 'checkout', 'color', 'state', 'resource_ids', 'resource_names', 'recurrence_id', 'request_id', 'partner_id', 'partner_invoice_id', 'reservation_line', 'whole_day', 'actions', 'expected_people', 'resource_detail', 'has_recurrence'];
            swif.data.addExtraFilter(params, 'currentCalendar', 'is_template', '=', false);
            swif.data.addExtraFilter(params, 'currentCalendar', 'state', 'in', ['active', 'waiting']);
            swif.data.addExtraFilter(params, 'currentCalendar', '|');
            swif.data.addExtraFilter(params, 'currentCalendar', '|');
            swif.data.addExtraFilter(params, 'currentCalendar', '&');
            swif.data.addExtraFilter(params, 'currentCalendar', 'checkin', '>=', start);
            swif.data.addExtraFilter(params, 'currentCalendar', 'checkin', '<=', end);
            swif.data.addExtraFilter(params, 'currentCalendar', '&');
            swif.data.addExtraFilter(params, 'currentCalendar', 'checkout', '>=', start);
            swif.data.addExtraFilter(params, 'currentCalendar', 'checkout', '<=', end);
            swif.data.addExtraFilter(params, 'currentCalendar', '&');
            swif.data.addExtraFilter(params, 'currentCalendar', 'checkin', '<=', start);
            swif.data.addExtraFilter(params, 'currentCalendar', 'checkout', '>=', end);

            if (selectedResources.length > 0) {
                if (noSelectedRessources) {
                    var user = swif.user.getAuthenticatedUserData()
                    swif.data.addExtraFilter(params, 'currentCalendar', '|');
                    swif.data.addExtraFilter(params, 'currentCalendar', 'partner_id', 'in', [user.partner_id[0]]);
                }
                swif.data.addExtraFilter(params, 'currentCalendar', 'reservation_line.product_id.id', 'in', selectedResources);
            }
            return params;
        }

        function routerProxyDismiss (data) {
            service.routerDefer.reject();
        }

        function getFullcalendar () {
            service.fullcalendar = swif.fullcalendar.getFullcalendar();
            return service.fullcalendar;
        }

        function getColor (reservation) {
            if (!reservation) {
                return '#000';
            }
            var resources = reservation.resource_ids || [];
            var color = '';
            if (service.fullcalendar.baseColorOnResource) {
                _.forEach(resources, function (resource_id) {
                    if (service.productType[resource_id] !== 'site') {
                        return; //do not exist forEach; just continue
                    }
                    color = service.productColor[resource_id];
                    if (color) {
                        return false; //exit forEach
                    }
                });
                if (!color) {
                    //again with the rest
                    _.forEach(resources, function (resource_id) {
                        color = service.productColor[resource_id];
                        if (color) {
                            return false; //exit forEach
                        }
                    });
                }
            } else {
                color = service.reservationStates[reservation.state].color;
            }
            return color;
        }

        function fromOdooEvents2Fullcalendar (event) {
            // TODO: ix the bug around color + don t use scope here
            var description = [];
            // resource_ids is a fields storing list of ids in a JSON format
            // must be parsed first
            var color = service.getColor(event);
            var allDay = event.whole_day;
            var ms = moment.utc(event.checkin);
            var me = moment.utc(event.checkout);
            var start = ms.toDate();
            var end = me.toDate();

            if (allDay) {
                if (me.hour() === 0 && me.minute() === 0) {
                    end = me.toDate();
                } else  {
                    end = me.add(1, 'days').startOf('day').toDate();
                }
            }
            // limited data for non manager users
            var ret = {
                start: start,
                end: end,
                timezone: 'UTC',
                allDay: allDay,
                color: color,
                className: event.state === 'waiting' ? 'planning-event-disabled' : ''
            };
            // full data for managers users
            var can_see_it = service.canSeeEventDetails(event);
            if (can_see_it) {
                ret.title = event.name;
                ret.data = event;
                ret.description = description;
                ret.editable = event.actions.indexOf('update') !== -1;
            }
            return ret;
        }

        function canSeeEventDetails (event) {
            var user = swif.user.getAuthenticatedUserData();
            var ability = openresaRightsService.getUserAbility();
            var can_see_it;
            // @TODO: refactor the following IF statement:
            // - is.manager replaced by managed_bookables (IDS) check
            //   is.agent should be replaced by an atomic right (server-side TODO)
            if(ability.is.manager || ability.is.agent) {
                can_see_it = true;
            }
            if (event.partner_invoice_id && user.partner_id) {
                if (event.partner_invoice_id[0] === user.address_id[0]) {
                    can_see_it = true;
                }
            }
            return can_see_it;
        }

        function loadProductColors (filter) {
            var copy = angular.copy(filter);
            copy.limit = 0;
            copy.fields = ['id', 'color', 'name', 'type_prod'];
            swif.data.searchRead('product', copy)
            .then(function (products) {
                _.forEach(products.records, function (product) {
                    if (product.color) {
                        service.productColor[product.id] = product.color;
                        service.productName[product.id] = product.name;
                        service.productType[product.id] = product.type_prod;
                    }
                });
            });
        }

        function addBookableExtraFilter (params, type_id) {
            var user = swif.user.getAuthenticatedUserData();
            var ability = openresaRightsService.getUserAbility();

            // Resource is an officer, team or supplier or...
            swif.data.addExtraFilter(params, 'planning', '|');
            swif.data.addExtraFilter(params, 'planning', 'type_prod', 'in', ['user', 'team', 'organization'])

            // ...one of these
            if (ability.is.manager) {
                //interval_booking and (service in mine or service not precised) OR(1) my service managed it Or(2) I managed it
                swif.data.addExtraFilter(params, 'planning', '|');
                swif.data.addExtraFilter(params, 'planning', '|');

                swif.data.addExtraFilter(params, 'planning', '&');
                swif.data.addExtraFilter(params, 'planning', 'internal_booking', '=', true);
                swif.data.addExtraFilter(params, 'planning', 'service_bookable_ids', 'in', angular.copy(user.managed_bookable_service_ids));

                swif.data.addExtraFilter(params, 'planning', '&');
                swif.data.addExtraFilter(params, 'planning', 'internal_booking', '=', true);
                swif.data.addExtraFilter(params, 'planning', 'service_bookable_ids', '=', false);
                //+I manage
                swif.data.addExtraFilter(params, 'planning', '|');
                swif.data.addExtraFilter(params, 'planning', 'resa_service_manager_ids', 'in', angular.copy(user.managed_bookable_service_ids));
                swif.data.addExtraFilter(params, 'planning', 'resa_user_manager_ids', 'in', [angular.copy(user.id)]);
            } else if (ability.is.internal) {
                swif.data.addExtraFilter(params, 'planning', 'internal_booking', '=', true);

                swif.data.addExtraFilter(params, 'planning', '|');
                swif.data.addExtraFilter(params, 'planning', 'service_bookable_ids', 'in', user.service_ids);
                swif.data.addExtraFilter(params, 'planning', 'service_bookable_ids', '=', false);
            } else if (ability.is.external) {
                swif.data.addExtraFilter(params, 'planning', 'external_booking', '=', true);

                swif.data.addExtraFilter(params, 'planning', '|');
                swif.data.addExtraFilter(params, 'planning', 'partner_type_bookable_ids', 'in', type_id);
                swif.data.addExtraFilter(params, 'planning', 'partner_type_bookable_ids', '=', false);
            } else {
                //user must be qualified to see bookable
                // id is never false, so we don't get any bookable resssources
                swif.data.addExtraFilter(params, 'planning', 'id', '=', false);
            }
        }

        function getSiteParams (type_id) {
            var params = {
                fields: ['id', 'name', 'complete_name', 'color', 'product_id', 'accommodation_capacity'],
                domain: []
            };
            swif.data.sortOn(params, 'name', 'ASC');
            service.addBookableExtraFilter(params, type_id);
            return params;
        }

        function getEquipmentParams (type_id) {
            var params = {
                fields: ['id', 'name', 'complete_name', 'color', 'product_product_id'],
                domain: []
            };
            swif.data.sortOn(params, 'name', 'ASC');
            service.addBookableExtraFilter(params, type_id);
            return params;
        }

        function openModal (contentType, actionType, action, model, options) {
            var actionDef = swif.action.getActionById(contentType, actionType, action, model);
            if (actionDef) {
                swif.action.dispatch(contentType, actionDef, model, options);
            }
        }

        function preModal (data) {

        }

        function preValidate (data) {
            var ret = true;
            if (data.action.id === 'edit') {
                ret = openresaBookingService.save(data.model);
            } else if (data.action.id === 'add') {
                ret = openresaBookingService.save(data.model);
            } else if (data.action.id === 'confirm') {
                data.model.state = 'active';
            } else if (data.action.id === 'refuse') {
                data.model.state = 'inactive';
                ret = openresaBookingService.save(data.model);
            }
            return ret;
        }

        function routerDispatch (data) {
            var ret = true;
            var options;
            if (_.contains(service.ROUTER_ACTIONS, data.action.id) && data.model._router) {
                var action = data.action.id.replace('router_', '');
                // if the routed action is on a Request
                if (data.model._router.action === 'request') {
                    // dismissCallback is added to modal.js,
                    // it's triggered when modal is dismissed (close button, etc.)
                    options = {
                        preModal: openresaRequestService.preModal,
                        preValidate: openresaRequestService.preValidate,
                        callback: requestCallback,
                        dismissCallback: service.routerProxyDismiss
                    };
                    var requestModel = {};
                    if (data.model.request_id) {
                        requestModel.id = data.model.request_id[0];
                    }
                    ret = swif.data.get('reservationRequest', requestModel.id || 0)
                    .then(function (res) {
                        _.merge(requestModel, res);
                        openModal('reservationRequest', 'primary', action, requestModel, options);
                        return true;
                    });
                }
                // or if the routed action is on a Booking
                else {
                    options = {
                        preModal: service.preModal,
                        // preValidate: service.bookings.routerProxy,
                        preValidate: service.preValidate,
                        callback: service.callback,
                        dismissCallback: service.routerProxyDismiss
                    };
                    openModal('reservation', 'primary', action, data.model, options);
                    ret = true;
                }
            }
            return ret;
        }

        function callback (err, data) {
            service.routerDefer.resolve(data);
        }

        function requestCallback (err, data) {
            openresaRequestService.callback(err, data);
            service.routerDefer.resolve(data);
        }

        return service;
    }

})();
